module.exports = __webpack_public_path__ + "M-DCH2OwfI3May0Kx/rdc_pro_logo.svg";